import { Component, OnInit, AfterViewInit, ViewChildren, QueryList, inject, DestroyRef } from '@angular/core';
import { gsap } from 'gsap';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { ProductsService } from 'src/app/services/products.service';
import { PaymentsService } from '../services/payments.service';
import { User } from 'src/app/models/user.model';
import { DefaultProduct, GetStripeId, Product } from 'src/app/models/product.model';
import { reducedPrice } from 'src/app/utils/animation.utils';
import { TermsAndConditionsModalComponent } from '../terms-and-conditions-modal/terms-and-conditions-modal.component';
import { AccountService } from 'src/app/services/account.service';
import { ModalService } from '../services/modal.service';
import { LoginModalComponent } from '../login/login-modal/login-modal.component';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { HudComponent } from '../hud/hud.component';
import { ProductComponent } from '../product/product.component';
import { FooterComponent } from '../footer/footer.component';

@Component({
    selector: 'app-product-details',
    templateUrl: './product-details.component.html',
    styleUrls: ['./product-details.component.css'],
    imports: [HudComponent, RouterLink, ProductComponent, FooterComponent]
})
export class ProductDetailsComponent implements OnInit, AfterViewInit {

  private productsService = inject(ProductsService);
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private accountService = inject(AccountService);
  private paymentsService = inject(PaymentsService);
  private modalService = inject(ModalService);
  private destroyRef = inject(DestroyRef);

  @ViewChildren('moving') descriptionQuery: QueryList<any>;

  product: Product = DefaultProduct;
  description: string[] = [];
  error: Error;
  user: User;

  beta1Key = "Beta 1 Key"

  ngOnInit(): void
  {
    this.accountService.userObservable
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(
        {
          next: user => {
            if(user) {
              this.user = user;
            }
          },
          error: err => {
            this.error = err;
          }
        }
      )

    this.route.paramMap.subscribe( paramMap =>
    {
        const id = paramMap.get('id');
        if(id !== null)
        {
          this.product.id = parseInt(id);
          this.productsService.getProductById(this.product.id).subscribe(
            next => {
              this.product = next;
              if (this.paymentsService.getPercentOff()) {
                this.product.reduction = this.paymentsService.getPercentOff()
              }
              this.description = this.product.description.split(",");
            },
            (err) => {
              this.error = err;
              this.router.navigate([".."]);
            }
          )
        }
        else
          this.router.navigate([".."]);
    })
  }
  ngAfterViewInit(): void {
    this.descriptionQuery.changes.subscribe(_t => {
      const elementRef: any[] = [];
      this.descriptionQuery.forEach(component => elementRef.push(component.nativeElement));
      gsap.timeline()
        .staggerFromTo(elementRef, 0.5, { opacity: 0, x: 400 }, { opacity: 1, x: 0 }, 0.2)
    })
  }

  ShowKey(value: string) {
    for (const desc in this.description) {
      if (this.description[desc].includes(value)) {
        return true;
      }
    }
    return false;
  }

  getReducedPrice(): number
  {
    return reducedPrice(this.product)
  }

  onBuyEvent(product: Product)
  {
    const itemId = GetStripeId(product)
    if (this.user?.isLogin) {
      if (!this.user.has_accepted_termsAndConditions) {
        const termsAndConditionsModal = this.modalService.open(TermsAndConditionsModalComponent, { size: 'lg', modalDialogClass: 'modal-dialog-centered' });
        termsAndConditionsModal.componentInstance.SetItemId(itemId);
      }
      else {
        this.paymentsService.checkout(itemId).subscribe(
          () => {
          },
          (error) => {
            this.error = error;
          }
        )
      }
    } else {
      const _loginModal = this.modalService.open(LoginModalComponent, { size: 'lg', modalDialogClass: 'modal-dialog-centered' });
    }
  }

}
